const apis = {
    saveUser:'/renren-fast/app/audience/save',
    getMeetingInfo: '/renren-fast/app/audience/meetingInfo/',
    getsignUpInfo:'/renren-fast/app/audience/signUp/',
    getHotelList:'/renren-fast/app/hotel/hotel/',
    getRoomList: '/renren-fast/app/hotel/hotelRoom/',
    submitBookOrder: '/renren-fast/app/hotel/save',
    getOrderList:'/renren-fast/app/audienceCenter/hotelOrder',
    sendCode:'/renren-fast/app/audienceCenter/sendCode',
    getUserinfo:'/renren-fast/app/audienceCenter/getAudienceMobile',
    getEditUserinfo:'/renren-fast/app/audienceCenter/getAudienceInfo',
    getEditInvoice:'/renren-fast/app/audienceCenter/getInvoice',
    setInvoice:'/renren-fast/app/audienceCenter/saveInvoice',
    getWhiteList: '/renren-fast/app/audienceCenter/whiteList/',
    saveUserOrder: '/renren-fast/app/audienceOrder/save',
    getTicket: '/renren-fast/app/audienceCenter/getTicketInfo/',
    editUserInfo: '/renren-fast/app/audienceCenter/update',
    getOpenid:'/renren-fast/app/h5pay/redirectpay',
    h5webpay:'/renren-fast/app/h5pay/pay',
    pcwxPay: '/renren-fast/app/h5pay/pc/pay'
}
export default apis